import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";
import { serviceCatalog } from "@/data/services";
import { HERO_BACKGROUNDS } from "@/data/projectImages";
import PageHero from "@/components/PageHero";

const Services = () => {
  const { t } = useT();

  return (
    <div data-testid="services-page">
      <PageHero
        overline={t.services.overline}
        title={t.services.title}
        subtitle={t.services.subtitle}
        backgroundImage={HERO_BACKGROUNDS.services}
      />

      <section className="py-12 sm:py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200">
            {serviceCatalog.map((s) => {
              const Icon = s.icon;
              const item = t.services.items[s.key];
              return (
                <Link
                  key={s.slug}
                  to={`/dienstleistungen/${s.slug}`}
                  className="group relative bg-white overflow-hidden"
                  data-testid={`services-item-${s.slug}`}
                >
                  <div className="aspect-[16/10] overflow-hidden bg-gradient-to-br from-zinc-100 to-zinc-200 relative">
                    {s.image ? (
                      <img src={s.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <Icon size={80} className="text-zinc-300 group-hover:text-red-600/30 transition-colors" strokeWidth={1} />
                      </div>
                    )}
                  </div>
                  <div className="p-5 sm:p-8">
                    <Icon size={28} className="text-red-600" strokeWidth={1.5} />
                    <h2 className="mt-4 sm:mt-5 font-display font-bold text-xl sm:text-2xl text-zinc-900">{item.title}</h2>
                    <p className="mt-2 sm:mt-3 text-sm text-zinc-600 leading-relaxed">{item.short}</p>
                    <span className="mt-4 sm:mt-6 inline-flex items-center gap-2 text-sm font-bold text-zinc-900 group-hover:text-red-600 transition-colors">
                      {t.common.learn_more} <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-14 sm:py-20 lg:py-28 bg-zinc-50 border-t border-zinc-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-display font-bold tracking-tighter text-zinc-900">
            {t.services.detail_cta_title}
          </h2>
          <p className="mt-5 text-base text-zinc-600 leading-relaxed">{t.services.detail_cta_text}</p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link to="/kontakt" className="btn-primary" data-testid="services-cta-contact">
              {t.common.cta_offer} <ArrowRight size={16} />
            </Link>
            <a href="tel:+41796070148" className="btn-outline" data-testid="services-cta-call">
              <Phone size={16} /> {t.common.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
